import React from 'react';
import { styled, CommonStyles, Caption } from '@teko/ds-desktop';
import { FlashSaleFilled } from '@teko/ds-icon';
import { CountdownTime } from '../../CountdownTime/CountdownTime.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const background = "data:image/svg+xml;base64,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";
const FlashSaleBar = (_a) => {
  var _b = _a, {
    text,
    endAt
  } = _b, rest = __objRest(_b, [
    "text",
    "endAt"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    background
  }, rest), /* @__PURE__ */ React.createElement(IconWrapper, null, /* @__PURE__ */ React.createElement(FlashSaleFilled, {
    size: 16,
    color: "#ffd591"
  })), /* @__PURE__ */ React.createElement(StyledCaption, {
    level: 1,
    weight: "bold",
    color: "white"
  }, text), endAt && /* @__PURE__ */ React.createElement(CountdownTime, {
    endAt
  }));
};
const Wrapper = styled.div(({ background: background2, theme }) => `
    background: url("${background2}");
    padding: ${theme == null ? void 0 : theme.spacing.s4} ${theme == null ? void 0 : theme.spacing.s4};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
`, CommonStyles, "border-radius: 999px;");
const IconWrapper = styled.div(({ theme }) => `
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
    line-height: 16px;
  `);
const StyledCaption = styled(Caption)`
  text-transform: uppercase;
  flex: 1 0 auto;
`;

export { FlashSaleBar };
